var _defs, _rect, _path, _path2, _rect2, _path3, _path4, _rect3, _rect4, _path5, _path6, _path7, _path8, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecipients01 = function SvgRecipients01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 54.06,
    y1: 216.7,
    x2: 225.35,
    y2: 72.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -5.19,
    y1: 146.12,
    x2: 166.1,
    y2: 2.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 34.42,
    y1: 193.3,
    x2: 205.71,
    y2: 49.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 73.99,
    y1: 240.44,
    x2: 245.28,
    y2: 96.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 14.74,
    y1: 169.86,
    x2: 186.03,
    y2: 26.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 54.35,
    y1: 217.04,
    x2: 225.64,
    y2: 73.23,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 55.99,
    y1: 218.99,
    x2: 227.28,
    y2: 75.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 24.89,
    y1: 181.96,
    x2: 196.19,
    y2: 38.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -34.36,
    y1: 111.38,
    x2: 136.94,
    y2: -32.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -34,
    y1: 111.82,
    x2: 137.3,
    y2: -32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -13.32,
    y1: 136.44,
    x2: 157.97,
    y2: -7.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -1.21,
    y1: 150.87,
    x2: 170.09,
    y2: 7.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 19.81,
    y1: 175.9,
    x2: 191.11,
    y2: 32.09,
    xlinkHref: "#linear-gradient"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 96.87,
    y: 156.25,
    width: 6.25,
    height: 43.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.25,56.25v3.12c0,10.35,8.4,18.74,18.75,18.75,10.35-.01,18.74-8.4,18.75-18.75v-3.12c0-10.36-8.39-18.75-18.75-18.75s-18.75,8.39-18.75,18.75ZM87.5,56.25c0-6.9,5.6-12.5,12.5-12.5s12.5,5.6,12.5,12.5v3.12c0,6.9-5.6,12.5-12.5,12.5s-12.5-5.6-12.5-12.5v-3.12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M118.75,81.25h-37.5c-8.63.01-15.61,7-15.63,15.63v42.19c0,6.04,4.9,10.94,10.94,10.94,1.68,0,3.26-.41,4.69-1.09v51.09h6.25v-90.63h-6.25v29.69c0,2.59-2.1,4.69-4.69,4.69s-4.69-2.1-4.69-4.69v-42.19c0-5.18,4.2-9.38,9.38-9.38h37.5c5.18,0,9.38,4.2,9.38,9.38v42.19c0,2.59-2.1,4.69-4.69,4.69s-4.69-2.1-4.69-4.69v-29.69h-6.25v90.63h6.25v-51.09c1.43.68,3,1.09,4.69,1.09,6.04,0,10.94-4.9,10.94-10.94v-42.19c-.01-8.63-7-15.61-15.63-15.63Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 156.25,
    y: 146.88,
    width: 6.25,
    height: 43.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M140.63,50c.01,10.35,8.4,18.74,18.75,18.75,10.35-.01,18.74-8.4,18.75-18.75v-3.12c0-10.36-8.39-18.75-18.75-18.75s-18.75,8.39-18.75,18.75v3.12ZM146.87,46.87c0-6.9,5.6-12.5,12.5-12.5s12.5,5.6,12.5,12.5v3.12c0,6.9-5.6,12.5-12.5,12.5s-12.5-5.6-12.5-12.5v-3.12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M178.12,71.88h-37.5c-3.81,0-7.48,1.39-10.34,3.91l4.14,4.69c1.71-1.51,3.91-2.35,6.2-2.34h37.5c5.18,0,9.38,4.2,9.38,9.38v42.19c0,2.59-2.1,4.69-4.69,4.69s-4.69-2.1-4.69-4.69v-29.69h-6.25v90.63h6.25v-51.09c1.43.68,3,1.09,4.69,1.09,6.04,0,10.94-4.9,10.94-10.94v-42.19c-.01-8.63-7-15.61-15.62-15.62Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 140.63,
    y: 100,
    width: 6.25,
    height: 90.63
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 37.5,
    y: 146.88,
    width: 6.25,
    height: 43.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M40.63,68.75c10.35-.01,18.74-8.4,18.75-18.75v-3.12c0-10.36-8.4-18.75-18.75-18.75s-18.75,8.39-18.75,18.75v3.12c.01,10.35,8.4,18.74,18.75,18.75ZM28.12,46.87c0-6.9,5.6-12.5,12.5-12.5s12.5,5.6,12.5,12.5v3.12c0,6.9-5.6,12.5-12.5,12.5s-12.5-5.6-12.5-12.5v-3.12Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75,40.62c10.35-.01,18.74-8.4,18.75-18.75v-3.13c0-10.35-8.39-18.75-18.75-18.75s-18.75,8.39-18.75,18.75v3.13c.01,10.35,8.4,18.74,18.75,18.75ZM62.5,18.75c0-6.9,5.6-12.5,12.5-12.5s12.5,5.6,12.5,12.5v3.13c0,6.9-5.6,12.5-12.5,12.5s-12.5-5.6-12.5-12.5v-3.13Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M125,40.62c10.35-.01,18.74-8.4,18.75-18.75v-3.13c0-10.35-8.39-18.75-18.75-18.75s-18.75,8.39-18.75,18.75v3.13c.01,10.35,8.4,18.74,18.75,18.75ZM112.5,18.75c0-6.9,5.6-12.5,12.5-12.5s12.5,5.6,12.5,12.5v3.13c0,6.9-5.6,12.5-12.5,12.5s-12.5-5.6-12.5-12.5v-3.13Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M59.38,71.88H21.88c-8.62.01-15.61,7-15.62,15.62v42.19c0,6.04,4.9,10.94,10.94,10.94,1.68,0,3.26-.41,4.69-1.09v51.09h6.25v-90.63h-6.25v29.69c0,2.59-2.1,4.69-4.69,4.69s-4.69-2.1-4.69-4.69v-42.19c0-5.18,4.2-9.38,9.38-9.38h37.5c2.28,0,4.49.83,6.2,2.34l4.14-4.69c-2.86-2.52-6.53-3.91-10.34-3.91Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 53.13,
    y: 100,
    width: 6.25,
    height: 90.63
  })));
};
export default SvgRecipients01;